var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1 6 4 4 6-9","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

Check.defaultProps = {"fill":"none","height":"11","viewBox":"0 0 12 11","width":"12"};

module.exports = Check;

Check.default = Check;
